/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyContestDocument = {

	delete (context, contestDocumentId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-contest-document"
			+ "?contestDocumentId=" + contestDocumentId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest-document"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDownload (context, contestDocumentId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest-document/download"
			+ "?contestDocumentId=" + contestDocumentId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getReadOnly (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest-document/read-only"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, file, contestId, documentType, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest-document"
			+ "?file=" + file
			+ "&contestId=" + contestId
			+ "&documentType=" + documentType
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
